import { SVGProps, Ref, forwardRef } from 'react';

export const YandexCloudGrayscaleSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M8 15c-1.74-.042-2.428-1.205-2.638-2.328-.114-.61-.064-1.625 0-1.988.104-.59.272-1.439.458-2.424.266-1.411.973-2.214 2.498-2.5l2.495-.476c.066-.37.192-1.351.077-1.956C10.679 2.193 9.805 1.018 8.028 1 4.161 1 1 4.133 1 8s3.133 7 7 7"
            fill="#C6C6C6"
        />
        <path
            d="M8 1c1.74.042 2.6 1.207 2.81 2.33.114.61-.108 1.623-.172 1.986-.104.59-.272 1.439-.458 2.424-.266 1.411-.973 2.214-2.498 2.5l-2.322.456c-.066.37-.284 1.371-.17 1.976.212 1.134 1.006 2.31 2.782 2.328C11.839 15 15 11.867 15 8s-3.133-7-7-7"
            fill="#919191"
        />
        <path
            d="M10.638 5.317c-.104.59-.272 1.438-.458 2.423-.267 1.411-.973 2.214-2.499 2.5l-2.321.455.002-.01c.104-.591.272-1.44.458-2.425.266-1.41.973-2.214 2.498-2.5z"
            fill="white"
        />
    </svg>
));
YandexCloudGrayscaleSize16Glyph.displayName = 'YandexCloudGrayscaleSize16Glyph';
